import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { EmergencyOrdersUpload } from "./emergencyOrdersUpload";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { Link } from "react-router-dom";
import { showNotificationDialogEmergencyOrder } from "redux/actions/notificationEmergencyOrderActions";
import {
  postFileAccess,
  showErrorMessageByCode,
} from "services/commonServices";
import { SOMS_API_KEY } from "services/CONSTANTS";
import { useDispatch, useSelector } from "react-redux";
import ReactDOM from "react-dom/client";
import ReasonCodesPopup from "components/Validate/ReasonCodesPopup";
import { Provider } from "react-redux";
import { store as reduxStore, persistor } from "redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { BulkUpload } from "components/EmergencyOrderBulkUpload/BulkUpload";
import { PAGE, PO_ELEMENTS } from "components/common/CONSTANTS";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, pl: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

export const EmergencyOrdersUploadScreen = () => {
  const [value, setValue] = React.useState(0);
  const [isUploadAllowed, setUploadAllowed] = useState(false);
  const [isBballocAllowed, setBballocAllowed] = useState(false);
  const userType = useSelector((state) => state.user);
  const { accessiblePages } = userType.userType;
  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setUploadAllowed(
      accessiblePages[PAGE.UPLOAD_EMERGENCY_ORDERS.key].includes(
        PO_ELEMENTS.UPLOAD_EMERGENCY_ORDERS_TAB.UPLOAD_TAB
      )
    );
    setBballocAllowed(
      accessiblePages[PAGE.UPLOAD_EMERGENCY_ORDERS.key].includes(
        PO_ELEMENTS.UPLOAD_EMERGENCY_ORDERS_TAB.BBALLOC_TAB
      )
    );
  }, [accessiblePages]);

  const tabs = [];
  if (isUploadAllowed) tabs.push("upload");
  if (isBballocAllowed) tabs.push("bballoc");

  useEffect(() => {
    if (value >= tabs.length) {
      setValue(0);
    }
  }, [tabs.length, value]);

  const handleDownloadAndReadFile = () => {
    const width = 500;
    const height = 300;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    const newWindow = window.open(
      "",
      "_blank",
      `width=${width},height=${height},left=${left},top=${top}`
    );
    if (newWindow) {
      const container = newWindow.document.createElement("div");
      newWindow.document.body.appendChild(container);
      const root = ReactDOM.createRoot(container);
      root.render(
        <Provider store={reduxStore}>
          <PersistGate loading={null} persistor={persistor}>
            <ReasonCodesPopup />
          </PersistGate>
        </Provider>
      );
      newWindow.document.close();
    }
  };

  const downloadTemplate = () => {
    const request = {
      apikey: SOMS_API_KEY,
      params: {
        fileName: "emergencyOrderTemplate.csv",
        reportType: "template",
      },
    };

    postFileAccess(request)
      .then((response) => {
        const url = response.fileURL;
        const fileDownloadTag = document.createElement("a");
        fileDownloadTag.href = url;
        fileDownloadTag.click();
      })
      .catch((err) => {
        const { errTitle, errContent } = showErrorMessageByCode(err);
        dispatch(
          showNotificationDialogEmergencyOrder(errTitle, errContent, "Done")
        );
      });
  };

  return (
    <>
      <div className="mainPageStyling">
        <Typography component="h1" variant="h5">
          Upload Emergency Orders
        </Typography>
        <Box sx={{ width: "100%", mt: 2, pl: 0 }} className="tabStyling">
          <Box
            sx={{ borderBottom: 2, borderColor: "primary", height: "1.76rem" }}
          >
            <Tabs
              className="tabPanelStyling"
              value={value}
              onChange={handleChange}
              aria-label="customer demand tabs"
              textColor="primary.contrastText"
              sx={{
                minHeight: "1rem",
                "& button": {
                  backgroundColor: "secondary.light",
                  fontWeight: "bold",
                  width: "18vw",
                  minHeight: "1.6rem",
                  p: ".3em 0",
                  fontSize: "0.7rem",
                  textTransform: "capitalize",
                },
                "& .Mui-selected": {
                  backgroundColor: "primary.main",
                  color: "white",
                },
              }}
            >
              {isUploadAllowed && (
                <Tab label="Upload" {...a11yProps(tabs.indexOf("upload"))} />
              )}
              {isBballocAllowed && (
                <Tab
                  label="Emergency Orders BBALLOC File Upload"
                  {...a11yProps(tabs.indexOf("bballoc"))}
                />
              )}

              <div className="downloadLink">
                {tabs[value] === "upload" && (
                  <>
                    <FileDownloadOutlinedIcon
                      onClick={downloadTemplate}
                      style={{
                        height: "18px",
                        color: "#108810",
                        cursor: "pointer",
                        position: "relative",
                        top: "5px",
                      }}
                    />
                    <Typography>
                      <Link
                        style={{
                          color: "#108810",
                          cursor: "pointer",
                          fontSize: "12px",
                        }}
                        onClick={downloadTemplate}
                      >
                        Download Template
                      </Link>
                    </Typography>
                    <Typography>
                      <Link
                        style={{
                          color: "#108810",
                          cursor: "pointer",
                          fontSize: "12px",
                          marginLeft: "10px",
                        }}
                        onClick={handleDownloadAndReadFile}
                      >
                        View Reasons
                      </Link>
                    </Typography>
                  </>
                )}
              </div>
            </Tabs>
          </Box>

          {isUploadAllowed && (
            <TabPanel
              value={value}
              index={tabs.indexOf("upload")}
              component="div"
              className="uploadManualStyling"
            >
              <EmergencyOrdersUpload />
            </TabPanel>
          )}

          {isBballocAllowed && (
            <TabPanel
              value={value}
              index={tabs.indexOf("bballoc")}
              component="div"
              className="uploadManualStyling"
            >
              <BulkUpload />
            </TabPanel>
          )}
        </Box>
      </div>
    </>
  );
};
